import React from "react";
import Agent from "./agent.jsx";
export const getCancellationPreview = async (token, shopId) => {
  const { requests } = Agent();
  return await requests.get(
    `/AppointmentCancellation/preview?token=${token}`,
    null,
    shopId,
  );
};

export const cancelAppointment = async (token, shopId) => {
  const { requests } = Agent();
  const params = {
    Token: token,
  };
  return await requests.post(
    `/AppointmentCancellation/cancel`,
    params,
    null,
    shopId,
  );
};
